export default __webpack_public_path__ + "static/media/silhouette-guy4.cfbab5c3.svg";